import React from 'react';

const Separator = () => {
    return (
        <div className="relative mb-[22px]">
            <div className="absolute left-[-16px] right-[-16px] my-2 h-[8px]  border-t-2
            bg-gray-100 dark:bg-gray-900/50
            border-gray-200 dark:border-gray-900" />
        </div>
    );
};

export default Separator;
